import type { ColumnsType } from "antd/es/table/interface";
import { createElement } from "react";
import { buildColumns } from "@/views/Data/TrialIssues/utils";
import RiskScoreCell from "./RiskScoreCell";
import {
  COLUMN_WIDTHS,
  FIXED_COLUMNS,
  HIDDEN_COLUMNS,
  RISK_COLUMN_ORDER,
  SEARCHABLE_COLUMNS,
  TITLE_MAPPING,
} from "./utils";

export type RiskTableRow = Record<string, string | number | boolean | null>;

export const createRiskColumns = (
  rows: RiskTableRow[],
): ColumnsType<RiskTableRow> => {
  return buildColumns({
    rows,
    columnOrder: RISK_COLUMN_ORDER,
    titleMapping: TITLE_MAPPING,
    columnWidths: COLUMN_WIDTHS,
    searchableColumns: SEARCHABLE_COLUMNS,
    fixedColumns: FIXED_COLUMNS,
    hiddenColumns: HIDDEN_COLUMNS,
    customRender: (header, text, record) => {
      if (header !== "assessed_risk_score") return undefined;

      return createElement(RiskScoreCell, {
        value: text as RiskTableRow[string],
        band: record.band,
      });
    },
  }) as ColumnsType<RiskTableRow>;
};
